import React, { useEffect, useState } from 'react'
import { css } from 'styled-components'
import { LoaderButton } from '../../../../_components/LoaderButton'
import { S_InvoicesOverview } from '../../../ClientViews/UploadInvoices/S_UploadInvoices'
import { EditScheduleTable } from './EditScheduleTable/EditScheduleTable'
import { submitInvoiceSchedule } from '../../../../_services/lender.service'
import { thereAreInvoiceErrors, allPersisted, syncInvoices } from '../../../../_helpers/transient-invoices'
import { ScheduleFiles } from '../../lender/InvoiceSchedule/ScheduleFiles/ScheduleFiles'
import { StatusBanner } from '../../../../_components/StatusBanner'
import { S_Title } from '../../../../_components/Typography/Titles.styles'
import { S_PageHeader, S_PageHeaderRow } from '../../../../_components/layout/PageHeader/PageHeader.styles'
import { ScheduleTotals } from './ScheduleTotals/ScheduleTotals'

// TODO: There is no error handling, the component
// just crashes if the schedule or business is missing
// Rewrite to handle failures gracefully
export const CreateInvoicesRedesign = ({
  reloadSchedulePage,
  invoiceSchedule,
  business,
  isClientView = false,
  isDisabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const disabled = isDisabled
  const [invoices, setInvoices] = useState([])
  const [invoicesErrors, setInvoicesErrors] = useState()
  const [scheduleError, setScheduleError] = useState(null)
  const [reloadKey, setReloadKey] = useState(false)

  const validateSchedule = () => {
    if (invoices.length == 0) {
      setScheduleError('Please add at least 1 invoice to this schedule')
      setIsLoading(false)
      return false
    }
    if (thereAreInvoiceErrors(invoices)) {
      setScheduleError('Please fix all invoice-specific errors prior to submitting')
      return false
    }
    setScheduleError(null)
    return true
  }

  const handleSave = async () => {
    setIsLoading(true)

    await syncInvoices(invoices, invoiceSchedule.id)

    // Makes child component reload to update its state after save
    setReloadKey((value) => !value)
    reloadSchedulePage()
    setIsLoading(false)
  }

  const handleSubmitSchedule = async () => {
    setIsLoading(true)
    if (invoicesErrors?.length || thereAreInvoiceErrors(invoices) || scheduleError) {
      return
    }

    await syncInvoices(invoices, invoiceSchedule.id)

    submitInvoiceSchedule(invoiceSchedule.id)
      .then(() => {
        reloadSchedulePage('redirect_to_client_home')
        setIsLoading(false)
      })
      .catch((response) => {
        const errors = response?.data
        if (errors) {
          setErrors(errors)
        }
        setIsLoading(false)
      })
  }

  useEffect(() => {
    validateSchedule()
  }, [invoices])

  const setErrors = (errors) => {
    if (errors.invoice_errors && errors.invoice_errors.length) {
      let newInvoiceErrors = {}
      errors.invoice_errors.map((err) => {
        newInvoiceErrors[err.invoice_id] = err.errors
      })
      setInvoicesErrors(newInvoiceErrors)
    }
    if (errors.invoice_schedule_errors) {
      setScheduleError(errors.invoice_schedule_errors[Object.keys(errors.invoice_schedule_errors)[0]])
    }
  }

  const saveCss = css`
    margin-right: 10px;
  `

  return (
    <S_InvoicesOverview>
      <S_PageHeader>
        <S_PageHeaderRow>
          <S_Title marginBottom={'0'}>Invoice Schedule #{invoiceSchedule.batch_number}</S_Title>
          {scheduleError && <StatusBanner className={`error`} icon="error" message={scheduleError} />}
        </S_PageHeaderRow>
      </S_PageHeader>

      <div className={`business-selection`}>
        <div className="left">
          <ScheduleTotals disabled={disabled} invoiceSchedule={invoiceSchedule} isClientView={isClientView} />
        </div>
        <div className="right">
          <LoaderButton
            customCss={saveCss}
            disabled={scheduleError || allPersisted(invoices)}
            isLoading={isLoading}
            onClick={handleSave}
          >
            Save
          </LoaderButton>
          <LoaderButton disabled={scheduleError || disabled} isLoading={isLoading} onClick={handleSubmitSchedule}>
            Submit invoices
          </LoaderButton>
        </div>
      </div>

      <EditScheduleTable
        business={business}
        disabled={disabled}
        invoiceSchedule={invoiceSchedule}
        isClientView={isClientView}
        isLoading={isLoading}
        reloadKey={reloadKey}
        reloadSchedulePage={reloadSchedulePage}
        setInvoices={setInvoices}
      />

      <ScheduleFiles invoiceSchedule={invoiceSchedule} isClientView={isClientView} />
    </S_InvoicesOverview>
  )
}
